import * as React from "react";
import { useState } from "react";
import Header from "./Header";
import EmailSaver from "./EmailSaver";
import EmailList from "./EmailList";
import AuthWrapper from "./AuthWrapper";
import TabLayout from "./Layout/TabLayout";
import { makeStyles, tokens, shorthands } from "@fluentui/react-components";
import { Person24Regular } from "@fluentui/react-icons";
import { useIdentity } from "@workspace/identity-react";

interface AppProps {
  title: string;
}

const useStyles = makeStyles({
  root: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  userSection: {
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalL),
    backgroundColor: tokens.colorBrandBackground2,
    ...shorthands.borderBottom('1px', 'solid', tokens.colorBrandStroke1),
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    boxShadow: tokens.shadow2,
  },
  userIcon: {
    color: tokens.colorBrandForeground1,
  },
  userName: {
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
  },
  tabContent: {
    flex: 1,
    overflow: "hidden",
  },
  contentContainer: {
    height: "100%",
    overflow: "auto",
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL),
  }
});

const App: React.FC<AppProps> = (props: AppProps) => {
  const styles = useStyles();
  const { user, getAccessToken } = useIdentity();
  const [selectedTab, setSelectedTab] = useState("save");

  // Make getAccessToken available globally for the API service
  React.useEffect(() => {
    (window as any).getAccessToken = getAccessToken;
  }, [getAccessToken]);

  return (
    <AuthWrapper>
      <div className={styles.root}>
        <Header logo="assets/logo-filled.png" title={props.title} message="Email Management" />
        
        {user && (
          <div className={styles.userSection}>
            <Person24Regular className={styles.userIcon} />
            <div>
              <div className={styles.userName}>{user.emailAddress || 'User'}</div>
              <div style={{ fontSize: tokens.fontSizeBase200 }}>Signed in</div>
            </div>
          </div>
        )}
        
        <div className={styles.tabContent}>
          <TabLayout selectedTab={selectedTab} onTabChange={setSelectedTab}>
            <div className={styles.contentContainer}>
              {selectedTab === "save" && <EmailSaver />}
              {selectedTab === "list" && <EmailList />}
            </div>
          </TabLayout>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default App;
